// extracted by mini-css-extract-plugin
module.exports = {"Counter":"app-javascript-tools-counter-style__Counter--OmI5A","Counter__text":"app-javascript-tools-counter-style__Counter__text--33kMb"};